import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import "./import-modal.scss";
import {
  S3_IMPORT_TEMPLATE_FOLDER,
  IMPORT_TEMPLATES,
} from "../../../constants/s3UploadTemplate";
import SelectInputComponent from "../select-input-component/select-input-component";

interface ImportModalProps {
  openModal: boolean;
  toggleModal: () => void;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  module?: string;
}

const ImportModal: React.FC<ImportModalProps> = ({
  openModal,
  toggleModal,
  handleFileChange,
  module,
}) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const [selectedTemplate, setSelectedTemplate] =
    React.useState<string>("AFP template");

  React.useEffect(() => {
    if (openModal) {
      setSelectedTemplate("AFP template");
    }
  }, [openModal]);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <Dialog
      open={openModal}
      onClose={toggleModal}
      maxWidth="sm"
      fullWidth
      className="import-modal-dialog"
    >
      <DialogTitle sx={{ m: 0, p: 2 }} className="import-modal-header">
        Import Bulk Records
        <IconButton
          aria-label="close"
          onClick={toggleModal}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers className="import-modal-content">
        <div className="import-modal-body">
          <div className="template-section">
            <p>
              Upload an XLSX or CSV file with the correct template in order to
              successfully import records in bulk.
            </p>
            {module === "Leads" && (
              <div className="template-select-section">
                <SelectInputComponent
                  options={[
                    { label: "AFP template", value: "AFP template" },
                    {
                      label: "FullCircle template",
                      value: "FullCircle template",
                    },
                  ]}
                  value={selectedTemplate}
                  onChange={(value: string) => setSelectedTemplate(value)}
                />
              </div>
            )}
            <div className="upload-section">
              <Button
                className="upload-button"
                onClick={handleButtonClick}
                variant="contained"
              >
                Select File to Upload
              </Button>
              <input
                type="file"
                ref={fileInputRef}
                className="file-input"
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept=".csv,.xlsx"
              />
            </div>
            <div
              className={
                module === "Leads"
                  ? " download-section download-section-leads"
                  : "download-section"
              }
            >
              <div className="template-group">
                <h4>AFP Standard Templates</h4>
                <div className="template-links">
                  <a
                    href={`${process.env.REACT_APP_S3_BULK_UPLOAD_BUCKET_DOMAIN}/${S3_IMPORT_TEMPLATE_FOLDER}/${module}/${IMPORT_TEMPLATES[`${module}XLSX` as keyof typeof IMPORT_TEMPLATES]}`}
                    className="download-link"
                  >
                    Download XLSX
                  </a>
                  <a
                    href={`${process.env.REACT_APP_S3_BULK_UPLOAD_BUCKET_DOMAIN}/${S3_IMPORT_TEMPLATE_FOLDER}/${module}/${IMPORT_TEMPLATES[`${module}CSV` as keyof typeof IMPORT_TEMPLATES]}`}
                    className="download-link"
                  >
                    Download CSV
                  </a>
                </div>
              </div>
              {module === "Leads" && (
                <div className="template-group">
                  <h4>FullCircle Templates</h4>
                  <div className="template-links">
                    <a
                      href={`${process.env.REACT_APP_S3_BULK_UPLOAD_BUCKET_DOMAIN}/${S3_IMPORT_TEMPLATE_FOLDER}/${module}/${IMPORT_TEMPLATES[`${module}FullCircleXLSX` as keyof typeof IMPORT_TEMPLATES]}`}
                      className="download-link"
                    >
                      Download XLSX
                    </a>
                    <a
                      href={`${process.env.REACT_APP_S3_BULK_UPLOAD_BUCKET_DOMAIN}/${S3_IMPORT_TEMPLATE_FOLDER}/${module}/${IMPORT_TEMPLATES[`${module}FullCircleCSV` as keyof typeof IMPORT_TEMPLATES]}`}
                      className="download-link"
                    >
                      Download CSV
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImportModal;
